import { useContext } from 'react';
import type { PickFilterValues } from '../types';
import { PickFilterContext } from './pickFilterContextState';

export function usePickFilterContext() {
  const context = useContext(PickFilterContext);
  if (!context) {
    throw new Error('usePickFilterContext must be used within PickFilterProvider');
  }
  return context;
}

export function usePickFilterValues<
  TFilters extends PickFilterValues = PickFilterValues,
>(): TFilters {
  const { values } = usePickFilterContext();
  return values as TFilters;
}
